<template>
  <!-- Age Verification Modal -->
  <div class="modal fade" id="ageVerificationModal" tabindex="-1" aria-labelledby="ageVerificationModalLabel" 
       ref="modalRef" data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content bg-dark text-light border-0">
        <div class="modal-body p-0">
          <div class="age-verification-wrapper">
            <!-- Logo or Icon -->
            <div class="text-center mb-3">
              <i class="bi bi-shield-check age-icon"></i>
            </div>
            
            <h3 class="modal-title fw-bold mb-4">Verificación de edad</h3>
            
            <div class="age-question mb-4">
              <h4 class="fw-normal">¿Eres mayor de 18 años?</h4>
              <p class="text-white-50">Este sitio está destinado a personas mayores de edad.</p>
            </div>
            
            <div class="disclaimer mb-4">
              <div class="disclaimer-header d-flex align-items-center mb-2">
                <i class="bi bi-exclamation-triangle me-2"></i>
                <strong>Aviso importante</strong>
              </div>
              <p class="m-0">No comercializamos derivados del cannabis con THC.
              Nuestros productos son para uso exclusivo en cultivo.</p>
            </div>
            
            <div class="d-grid gap-3 d-md-flex justify-content-center mt-4">
              <button class="btn btn-outline-light px-4 py-2" @click="rejectAge">
                <i class="bi bi-x-lg me-2"></i>No, soy menor
              </button>
              <button class="btn btn-primary px-4 py-2" @click="confirmAge">
                <i class="bi bi-check-lg me-2"></i>Sí, soy mayor
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <section class="hero pt-4">
    <div class="grid-background"></div>
    <div class="container-fluid d-flex justify-content-center">
      <HeroCarousel />
    </div>
  </section>
  <!-- Products Section -->
  <section class="products-section py-5 mt-5" v-if="loadingOnSale || onSaleProducts.length > 0">
    <div class="container">
      <h2 class="display-4 text-center mb-4 text-gradient-primary">Productos En Oferta</h2>
      <ProductsCarousel 
        :products="onSaleProducts"
        :is-loading="loadingOnSale"
      />
    </div>
  </section>
  <!-- Asesoramiento section -->
  <section class="container-fluid d-flex justify-content-center align-items-center py-5 mb-5">
    <div class="container">
      <div class="row align-items-center justify-content-center">
        <div class="col-lg-5 col-12 order-md-1 order-2 text-center text-lg-start">
          <h2 class="display-3 text-white mb-3 text-gradient-primary">Cultiva calidad</h2>
          <p class="h5 text-white-50 mb-4 px-5 px-lg-2 mx-5 mx-lg-0">Consultanos para asesorarte a elegir la genética que buscas para tu cultivo ideal.</p>
          <a class="btn btn-primary fs-6" href="https://wa.me/+5491150542815" target="_blank">
            Contactanos</a>
        </div>
        <div class="col-lg-5 col-12 text-center text-lg-end order-md-2 order-1 mb-4 mb-lg-0">
          <img 
            src="@/assets/images/bsf-blisters.png" 
            alt="Asesoramiento" 
            class="asesoramiento-img" 
          >
        </div>
      </div>
    </div>
  </section>
    <section class="products-section py-5" v-if="loadingLatest || latestProducts.length > 0">
      <div class="container">
        <div class="d-flex flex-column align-items-center">
          <h2 class="display-4 text-center mb-2 text-gradient-primary">Últimos productos agregados</h2>
          <p class="text-center text-white-50">Descubre los productos más recientes en nuestro <a href="/productos" class="text-white-50 fw-light">catálogo</a>.
          </p>
        </div>
        <ProductsCarousel 
          :products="latestProducts"
          :is-loading="loadingLatest"
        />
      </div>
    </section>

    <!-- Asesoramiento section -->
    <section class="container-fluid d-flex justify-content-center align-items-center py-5 mb-5">
      <div class="container">
        <div class="row align-items-center justify-content-center">
          <div class="col-lg-5 col-12 text-center text-lg-end mb-4 mb-lg-0">
            <img 
              src="@/assets/images/illustrations/cogollo.png" 
              alt="Asesoramiento" 
              class="asesoramiento-img" 
            >
          </div>
          <div class="col-lg-5 col-12 text-center text-lg-start">
            <h2 class="display-3 text-white mb-3 text-gradient-primary">Asesoramiento personalizado</h2>
            <p class="h5 text-white-50 mb-4 px-5 px-lg-2 mx-5 mx-lg-0">¿Necesitas ayuda para elegir el producto ideal para tu cultivo? ¡Contáctanos!</p>
            <a class="btn btn-primary fs-6" href="https://wa.me/+541140583484" target="_blank">
              Contactanos</a>
          </div>
        </div>
      </div>
    </section>


  <FaqSection />

</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import HeroCarousel from '@/components/HeroCarousel.vue';
import ProductsCarousel from '@/components/ProductsCarousel.vue';
import FaqSection from '@/components/FaqSection.vue';
import { getProductsOnSale, getProducts } from '@/services/products';

// Age verification modal
import { Modal } from 'bootstrap';
const modalRef = ref(null);
let ageModal = null;

// Cookie handling functions
const checkAgeVerificationCookie = () => {
  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    const [name, value] = cookie.trim().split('=');
    if (name === 'ageVerified' && value === 'true') {
      return true;
    }
  }
  return false;
};

const setAgeVerificationCookie = () => {
  // Set cookie to expire in 30 days
  const expirationDate = new Date();
  expirationDate.setDate(expirationDate.getDate() + 30);
  document.cookie = `ageVerified=true; expires=${expirationDate.toUTCString()}; path=/`;
};

const confirmAge = () => {
  setAgeVerificationCookie();
  if (ageModal) {
    ageModal.hide();
  }
};

const rejectAge = () => {
  window.location.href = 'https://www.google.com';
};

// Separate loading states for each product type
const loadingOnSale = ref(true);
const loadingLatest = ref(true);
const onSaleProducts = ref([]);
const products = ref([]);

// Computed para asegurar que latestProducts siempre sea un array
const latestProducts = computed(() => {
  if (!Array.isArray(products.value?.results)) {
    return [];
  }
  return products.value.results.slice(0, 12); // Mostrar hasta 12 productos
});

onMounted(async () => {
  // Initialize age verification modal with a small delay for better UX
  setTimeout(() => {
    if (modalRef.value) {
      ageModal = new Modal(modalRef.value);
      if (!checkAgeVerificationCookie()) {
        ageModal.show();
      }
    }
  }, 500);

  try {
    loadingOnSale.value = true;
    loadingLatest.value = true;
    
    // Cargar productos en oferta y productos regulares de forma independiente
    const loadOnSaleProducts = getProductsOnSale()
      .then(response => {
        onSaleProducts.value = response?.results || [];
        // Pequeño retraso para evitar flasheo en la UI
        setTimeout(() => {
          loadingOnSale.value = false;
        }, 300);
      })
      .catch(error => {
        console.error('Error loading products on sale:', error);
        onSaleProducts.value = [];
        loadingOnSale.value = false;
      });
      
    const loadLatestProducts = getProducts({ page_size: 12 }) // Request only what we need
      .then(response => {
        products.value = response || { results: [] };
        // Pequeño retraso para evitar flasheo en la UI
        setTimeout(() => {
          loadingLatest.value = false;
        }, 300);
      })
      .catch(error => {
        console.error('Error loading latest products:', error);
        products.value = { results: [] };
        loadingLatest.value = false;
      });
    
    // Ejecutar ambas solicitudes en paralelo pero manejar errores independientemente
    await Promise.allSettled([loadOnSaleProducts, loadLatestProducts]);
    
  } catch (error) {
    console.error('Error loading home products:', error);
    onSaleProducts.value = [];
    products.value = { results: [] };
    loadingOnSale.value = false;
    loadingLatest.value = false;
  }
});
</script>

<script>
  export default{
    name: "AppHome"
  }
</script>

<style scoped>
.hero {
  min-height: 90vh;
  position: relative;
  background-color: var(--black-color);
  overflow: hidden;
}

.grid-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: 
    linear-gradient(var(--secondary-color) 1px, transparent 1px),
    linear-gradient(90deg, var(--secondary-color) 1px, transparent 1px);
  background-size: 100px 100px;
  background-position: center center;
  opacity: 0.2;
  pointer-events: none;
}

/* Añadir un gradiente para desvanecer el grid hacia abajo */
.grid-background::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 200px;
  background: linear-gradient(
    to bottom,
    transparent 0%,
    var(--black-color) 100%
  );
}

.hero-title {
  font-size: 4rem;
  font-weight: 700;
  line-height: 1.1;
}

@keyframes waveEffect {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%; 
  }
  100% {
    background-position: 0% 50%;
  }
}

.hero-wrapper {
  width: 100%;
  position: relative;
  z-index: 1;
  padding: 2rem 0;
}

.stock-badge {
  background-color: #222;
  padding: 1rem;
  border-radius: 0.5rem;
  color: white;
  transform: rotate(-3deg);
  width: fit-content;
  margin-top: -30px;
}
.stock-badge h2{
  font-size: 1.3rem;
}

.product-image {
  position: relative;
  transition: transform 0.3s ease;
  max-height: 400px;
  height: 100%;
  overflow: hidden;
  border-radius: 1rem;
  animation: fadeIn 1.5s ease-out;
  transition: 1s ease;
  filter: brightness(.8);
}

.product-image:hover {
  transform: scale(1.02);
  filter: brightness(1);
}

.combo-image {
  animation: appearFromMiddle .3s ease-out;
  filter: drop-shadow(0 0 .5rem rgba(58, 58, 58, 0.3));
}

.hero-text {
  animation: appearFromMiddle .5s ease-out;
}

@keyframes appearFromMiddle {
  from {
    transform: translateY(50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}


/* Responsive adjustments */
@media (max-width: 991.98px) {
  .hero {
    padding: 2rem 0;
  }
  .product-image {
    margin-top: 2rem;
  }
}

.display-2 {
  letter-spacing: 2px;
  line-height: 1.1;
}

.carousel-indicators {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -50px;
  padding: 0;
  z-index: 15;
}

.carousel-indicators button {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.5);
  border: 2px solid transparent;
  opacity: 0.5;
  transition: all 0.3s ease;
  margin: 0 5px;
}

.carousel-indicators button.active {
  background-color: var(--white-color);
  opacity: 1;
  transform: scale(1.2);
}

/* Remove default Bootstrap carousel controls if you don't need them */
.carousel-control-prev,
.carousel-control-next {
  display: none;
}

.products-section {
  background-color: var(--black-color);
  min-height: auto;
}

.section-title {
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 2rem;
  color: var(--white-color);
  text-align: center;
}

@media (max-width: 768px) {
  .hero{
    min-height: auto;
  }
  .hero-title {
    font-size: 3rem;
  }
  .section-title {
    font-size: 1.5rem;
    margin-bottom: 1.5rem;
  }
}
.asesoramiento{
  background-color: #ebebeb;
  border-radius: 30px;
  padding: 2rem;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
}

.asesoramiento img{
  width: auto;
  height: 800px;
}

.asesoramiento-img {
  max-width: 100%;
  height: auto;
  max-height: 800px;
  object-fit: contain;
}

@media (max-width: 991.98px) {
  .asesoramiento-img {
    max-height: 250px;
    margin: 1rem 0;
  }
}

/* Age Verification Modal Styles */
.modal-content {
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.6);
  overflow: hidden;
}

.age-verification-wrapper {
  padding: 2rem;
  background: var(--black-color-3);
}

.age-icon {
  font-size: 3rem;
  color: var(--primary-color, #0d6efd);
  margin-bottom: 0.5rem;
  animation: pulse 2s infinite;
}

.modal-title {
  color: white;
  font-size: 1.8rem;
  letter-spacing: 0.5px;
  text-align: center;
}

.age-question {
  text-align: center;
  padding: 0.5rem 1rem;
  border-radius: 8px;
}

.disclaimer {
  background: rgba(255, 255, 255, 0.05);
  padding: 1rem;
  border-radius: 10px;
  border-left: 4px solid var(--primary-color, #0d6efd);
  font-size: 0.95rem;
  transition: all 0.3s ease;
}

.disclaimer:hover {
  background: rgba(255, 255, 255, 0.08);
}

.disclaimer-header {
  color: var(--primary-color, #0d6efd);
}

.btn {
  transition: all 0.3s ease;
  border-radius: 8px;
  font-weight: 500;
}

.btn-primary {
  box-shadow: 0 4px 12px rgba(13, 110, 253, 0.3);
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 15px rgba(13, 110, 253, 0.4);
}

.btn-outline-light:hover {
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
}

@keyframes pulse {
  0% {
    opacity: 0.8;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.05);
  }
  100% {
    opacity: 0.8;
    transform: scale(1);
  }
}

/* Media queries for better responsive behavior */
@media (max-width: 576px) {
  .age-verification-wrapper {
    padding: 1.5rem;
  }
  
  .modal-title {
    font-size: 1.5rem;
  }
  
  .age-question h4 {
    font-size: 1.3rem;
  }
  
  .disclaimer {
    font-size: 0.85rem;
  }
}
</style>